import React from "react";
import { useLang } from "../i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative border-y border-border bg-surface overflow-hidden py-5 md:py-6">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-2xl md:text-4xl font-medium tracking-tight text-steel-300 px-6 md:px-10">
              {it}
            </span>
            <span className="h-2 w-2 rotate-45 bg-brand-orange" />
          </div>
        ))}
      </div>
    </div>
  );
}
